import React, { useState, useEffect } from "react";
import IdleTimeOutModal from "./IdleTimeOutModal";
import { useIdleTimer } from "react-idle-timer";

const IdleTimeOutHandler = (props) => {
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [focusAfterClose] = useState(true);
  const [lgroup, setLgroup] = useState('');
  const [orname, setOrname] = useState([]);

  const toggle = () => setOpen(!open);

  const onIdle = () => {
    setShow(true);
    toggle();
  };
  
  useIdleTimer({
    onIdle,
    timeout: 1000 * 60 * 30,
  });

  const handleContinue = () => {
    toggle();
    window.location.reload();
  };

  useEffect(() => {
    setLgroup(localStorage.getItem("group"));
  }, [])

  const handleLogout = () => {
    toggle();    
    if (lgroup === "admin") {
      localStorage.clear();
      window.localStorage.clear();
      window.location.reload(); 
      window.location.href = "/admin";
    } 
    // else if (lgroup === "trainee"){
    //   localStorage.clear();
    //   window.localStorage.clear();
    //   window.location.reload(); 
    //   window.location.href = `/${orname}`;
    // }
    else {
      localStorage.clear();
      window.localStorage.clear();
      window.location.reload(); 
      window.location.href = `/${orname}`;
    }
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/orgname/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => {
        setOrname(resp);
        localStorage.setItem("org", resp);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <div>
      <IdleTimeOutModal
        show={show}
        open={open}
        focusAfterClose={focusAfterClose}
        handleContinue={handleContinue}
        handleLogout={handleLogout}
      />
    </div>
  );
};

export default IdleTimeOutHandler;
